/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api.js';
export default {
  index: function() {
    return apiCtrl.get('/category');
  },
};
